<template>
    <div class="product-gallery">
        <div class="main" id="zoom">
            <Splide ref="mainSlider" :options="mainOptions" id="product-gallery">
                <SplideSlide v-for="(image, index) in images" :key="index" @click="lightboxVisible = true; imgIndex = index">
                    <figure :data-index="index">
                        <div class="image-wrapper">
                            <img :src="image" :alt="productName + ' od ' + brandName" loading="lazy">
                        </div>
                    </figure>
                </SplideSlide>

                <template #after-track>
                    <div class="splide__arrows" :class="{ hidden: arrowsVisible }">
                        <button class="splide__arrow splide__arrow--prev prev">
                            <img src="/img/svg/arrow-left.svg">
                        </button>
                        <button class="splide__arrow splide__arrow--next next">
                            <img src="/img/svg/arrow-right.svg">
                        </button>
                    </div>
                </template>
            </Splide>
        </div>

        <div class="nav">
            <Splide ref="navSlider" :options="navOptions">
                <SplideSlide v-for="(image, index) in images" :key="index">
                    <figure :data-index="index">
                        <img :src="image"
                             :alt="productName + ' od ' + brandName"
                             loading="lazy"
                        >
                    </figure>
                </SplideSlide>
            </Splide>
        </div>

        <vue-easy-lightbox
            :visible="lightboxVisible"
            :imgs="images"
            :index="imgIndex"
            @hide="lightboxVisible = false"
        >
        </vue-easy-lightbox>
    </div>
</template>

<script>
import { onMounted, ref, reactive, toRefs } from 'vue'

import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

import VueEasyLightbox from 'vue-easy-lightbox'

export default {

    props: [
        'images',
        'badges',
        'variationValues',
        'productName',
        'brandName'
    ],

    components: {
        Splide,
        SplideSlide,
        VueEasyLightbox
    },

    setup(props) {

        const state = reactive({
            lightboxVisible: false,
            imgIndex: 0,
            arrowsVisible: props.images.length === 1,
            hasDiscount: false,
            // oldPrice: Math.max(... props.variationValues.map(item => item.old_price)),
            // mainPrice: Math.min(... props.variationValues.map(item => item.main_price)),
        })

        const mainSlider = ref(),
              navSlider  = ref();

        const mainOptions = {
            type: 'loop',
            pagination: false,
            arrows: true
        }

        const navOptions = {
            type: 'slide',
            perPage: 3,
            gap: '14px',
            arrows: false,
            isNavigation: true,
            breakpoints: {
                567: {
                    perPage: 2
                }
            }
        }

        onMounted( () => {
            const navSplide = navSlider.value?.splide

            if ( navSplide ) mainSlider.value?.sync(navSplide)

            /*props.variationValues.forEach( value => {
                if ( parseFloat(value.old_price) > parseFloat(value.main_price ) )
                    state.hasDiscount = true
            })*/
        })

        // function onArrowsMounted() {
        //     console.log('mounted')
        //     if ( props.images.length === 1 ) {
        //         console.log(document.querySelector('.product-gallery .splide__arrows'))
        //     }
        // }

        return {
            ...toRefs(state),
            mainSlider,
            navSlider,
            mainOptions,
            navOptions,
            // onArrowsMounted
        }
    }
}
</script>
